import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      HEADER: "Legg til dagligvarer",
      GROCERIES: "Dagligvarer",
      DELIVERY_DATE: (dateString: string) => `Leveres ${dateString}`,
      TOTAL: "Totalt",
      NEXT_BUTTON: "Fortsett",
      MODAL_CLOSE_TEXT: "Lukk",
      SEARCH: "Søk",
      COULD_NOT_FIND_ANY: "Fant ingen matvarer...",
      BACK: "Tilbake",
      BACK_TO_TOP: "Tilbake til toppen",
      POINTS: "poeng",
      SEARCH_AMONG_X_ITEMS: (x: number) => `Søk blant ${x} varer`,
    },
    se: {
      HEADER: "Lägg till livsmedel",
      GROCERIES: "Livsmedel",
      DELIVERY_DATE: (dateString: string) => `Levereras ${dateString}`,
      TOTAL: "Totalt",
      NEXT_BUTTON: "Fortsätt",
      MODAL_CLOSE_TEXT: "Stänga",
      SEARCH: "Sök",
      COULD_NOT_FIND_ANY: "Kunde inte hitta något...",
      BACK: "Tillbaka",
      BACK_TO_TOP: "Tilbaka till toppen",
      POINTS: "poäng",
      SEARCH_AMONG_X_ITEMS: (x: number) => `Sök bland ${x} varor`,
    },
    dk: {
      HEADER: "Tilføj specialvarer",
      GROCERIES: "Specialvarer",
      DELIVERY_DATE: (dateString: string) => `Leveres ${dateString}`,
      TOTAL: "I alt",
      NEXT_BUTTON: "Gå videre",
      MODAL_CLOSE_TEXT: "Luk",
      SEARCH: "Søg",
      COULD_NOT_FIND_ANY: "Kunne ikke finde noget...",
      BACK: "Tilbage",
      BACK_TO_TOP: "Tilbage til toppen",
      POINTS: "point",
      SEARCH_AMONG_X_ITEMS: (x: number) => `Søg blandt ${x} varer`,
    },
  } as const
)[language];
